import { useEffect, useState } from 'react'

const API_BASE = process.env.REACT_APP_API_URL ?? ''

export const useMenuApi = (options = {}) => {
  const { load = true, withAuth = false } = options
  const [menu, setMenu] = useState(null)
  const [loading, setLoading] = useState(load)
  const [error, setError] = useState(null)

  const token = withAuth
    ? localStorage.getItem('menu_admin_token') || ''
    : ''

  useEffect(() => {
    if (!load) return
    const fetchMenu = async () => {
      try {
        setLoading(true)
        const res = await fetch(`${API_BASE}/api/menu`)
        if (!res.ok) throw new Error('Erreur de chargement du menu')
        const data = await res.json()
        setMenu(data)
      } catch (err) {
        console.error(err)
        setError("Impossible de charger le menu pour l'instant.")
      } finally {
        setLoading(false)
      }
    }
    fetchMenu()
  }, [load])

  const saveMenu = async (updatedMenu, { silent = false } = {}) => {
    try {
      if (!silent) {
        setLoading(true)
        setError(null)
      }
      const res = await fetch(`${API_BASE}/api/menu`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(withAuth && token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(updatedMenu),
      })
      if (!res.ok) throw new Error('Erreur de sauvegarde du menu')
      const data = await res.json()
      // Use the server's returned menu which may include image URLs preserved
      // from the Cloudinary backup (via mergeMenuImages on the server side).
      setMenu(data.menu || updatedMenu)
      // If the Cloudinary backup failed, propagate a warning so the admin knows
      // their changes may be lost on the next Railway redeploy.
      if (data.cloudinaryError) {
        return 'cloudinary_error'
      }
      return true
    } catch (err) {
      console.error(err)
      if (!silent) setError("Erreur lors de l'enregistrement du menu")
      return false
    } finally {
      if (!silent) setLoading(false)
    }
  }

  return { menu, setMenu, loading, error, saveMenu }
}